import { useMemo } from 'react';
import Top17Cards from './Top17PerformanceCards';
import EprBiometricCharts from './EprBiometricsCharts';
import TopBottomPerformers from './TopBottomPerformers';
import ScopeProductivityChart from './ScopeProductivityChart';
import BiometricEfficiencyChart from './BiometricEfficiencyChart';
import ClientProductivityChart from './ClientProductivityChart';
// import ClientRevenueChart from './ClientRevenueChart';
// import PerformanceReportsFilter from './PerformanceReportsFilter';
import { useState } from 'react';
import TopBottomAllRounders from './TopBottomAllRounders';

const PerformanceReports = ({ filters }) => {
  // const [filters, setFilters] = useState({
  //   client: '',
  //   scope: '',
  //   user: '',
  //   startDate: '',
  //   endDate: '',
  //   status: '',
  // });

  // const handleFilterChange = (updatedFilters) => {
  //   const mappedFilters = {
  //     clientId: updatedFilters.client || '',
  //     scopeId: updatedFilters.scope || '',
  //     employeeId: updatedFilters.user || '',
  //     startDate: updatedFilters.startDate || '',
  //     endDate: updatedFilters.endDate || '',
  //     status: updatedFilters.status || '',
  //   };
  //   setFilters(mappedFilters);
  // };
    const mappedFilters = useMemo(() => ({
    clientId: filters.client || '',
    scopeId: filters.scope || '',
    employeeId: filters.user || '',
    startDate: filters.startDate || '',
    endDate: filters.endDate || '',
    monthYear: filters.monthYear || '',
  }), [filters]);
  return (
    <div className="bg-gray-200 p-4 rounded-lg shadow-lg">
      {/* <h2 className="text-2xl font-bold mb-4">Performance Reports</h2> */}
      {/* <PerformanceReportsFilter isChecked={false} onFilterChange={handleFilterChange} /> */}
      <Top17Cards filters={mappedFilters} />
      <EprBiometricCharts filters={mappedFilters} />
      <TopBottomAllRounders filters={mappedFilters} />
      <TopBottomPerformers filters={mappedFilters} />
      <ScopeProductivityChart filters={mappedFilters} />
      <ClientProductivityChart filters={mappedFilters} />
      <BiometricEfficiencyChart filters={mappedFilters} />
      {/* <ClientRevenueChart filters={filters} /> */}
    </div>
  );
};

export default PerformanceReports;
